import { isArray, isFunction } from '@qcwp/utils'
import type { NFormItem } from 'naive-ui/es/'
/**
 * 触发NForm表单校验
 * @param el c
 * @returns
 */
export async function validateHandle(el: any) {
  let isOk = false
  let errorContent = false

  await unref(el)?.validate((errors: any) => {
    if (!errors)
      isOk = true
    else
      errorContent = errors
  })

  return {
    isOk,
    errors: errorContent,
  }
}
export function checkError(error: any, type: 'toast' | 'dialog' = 'dialog', to = 'body') {
  if (error && isArray(error) && error.length > 0) {
    const errorItem = error[0][0]
    if (errorItem && errorItem.message) {
      nextTick(() => {
        const el = document.querySelector('.n-form-item-blank--error') as HTMLElement
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
      type === 'toast'
        ? vantToast({ message: errorItem.message, teleport: to })
        : vantDialog({
          title: '提示',
          message: `请完善表单数据，${errorItem.message}`,
        })
    }
  }
  else {
    vantDialog({
      title: '提示',
      message: `操作失败，请重试<<${error}>>`,
    })
  }
}
/**
 * 恢复表单验证状态
 */
export function formRestoreValidation<T extends {}, KEYS extends keyof T>(
  formData: Ref<T>,
  keys: KEYS[],
  watchHandlers?: Record<KEYS, (nv: T[KEYS], ov: T[KEYS]) => void>,
) {
  const refEls = {} as Record<KEYS, Ref<typeof NFormItem | null>>
  const handler = {} as Record<KEYS, (nv: T[KEYS], ov: T[KEYS]) => void>

  keys.forEach((key) => {
    refEls[key] = ref<typeof NFormItem | null>(null)
    handler[key] = (watchHandlers?.[key] && isFunction(watchHandlers[key]))
      ? watchHandlers[key]
      : (nv, ov) => {
          // console.log('watch', key, nv, ov)
          if (nv !== ov) {
            // refEls[key].value?.validate()
            refEls[key].value?.restoreValidation?.()
          }
        }
  })
  function mountedHandle() {
    const stop: any[] = []
    keys.forEach((key) => {
      const fn = handler[key]
      if (!fn)
        return

      stop.push(watch(() => formData.value[key], fn))
    })

    onUnmounted(() => {
      stop.forEach(fn => fn && isFunction(fn) && fn())
    })
  }

  onMounted(mountedHandle)
  return {
    refEls,
    mountedHandle,
    restoreValidationInitHandle: mountedHandle,
  }
}
